import { Component, OnInit, OnDestroy } from "@angular/core";
import { GridOptions } from "ag-grid";
import { QuizService } from "./quiz.service";
import { isQuizGridRow, QuizClass, QuizGridRow } from "./quiz.class";
import { Subscription } from "rxjs";
import { SweetAlertHelper } from "app/core/helpers/sweet-alert-helper.service";
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { finalize } from "rxjs/operators";
import { BooleanCheckComponent } from "../A2-utils/grid-components/boolean-check/boolean-check.component";
@Component({
  selector: "app-quiz",
  templateUrl: "./quiz.component.html",
  styleUrls: ["./quiz.component.scss"],
})
export class QuizComponent implements OnInit, OnDestroy {
  protected gridQuiz: GridOptions;
  protected showForm: boolean = false;
  protected formEdit: boolean = false;
  protected showDisabled: boolean = false;
  subscriptions: Subscription[] = [];
  constructor(private _serviceQuiz: QuizService,  private sweetAlertHelper: SweetAlertHelper, private loading: T2LoadingService) {}

  ngOnInit() {
    this.initGrid();

    this.subscriptions.push(
      this._serviceQuiz.modalStatus$.subscribe({
        next: (status) => {
          this.inCancelForm(status);
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );

    this.subscriptions.push(
      this._serviceQuiz.refreshQuizGrid$.subscribe({
        next: (refresh) => {
          if (refresh) {
            this.listQuiz();
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
  }

  initGrid() {
    this.gridQuiz = <GridOptions>{
      rowSelection: "single",
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressHorizontalScroll: true,
      columnDefs: [
        {
          colId: "quizId_select",
          width: 20,
          checkboxSelection: true,
        },
        {
          headerName: "Id",
          colId: "quizid",
          width: 25,
          field: "quizid",
          cellStyle: { "text-align": "right" },
        },
        {
          headerName: "Description",
          field: "description",
          colId: "description",
        },
        {
          headerName: "Passed score",
          field: "passscore",
          width: 55,
          colId: "passscore",
          cellStyle: { "text-align": "right" },
        },
        {
          headerName: "Active",
          field: "isactive",
          colId: "isactive",
          width: 55,
          cellRendererFramework: BooleanCheckComponent
        }
      ],
      onGridReady: () => {
        if (this.gridQuiz && this.gridQuiz.api) {
          this.gridQuiz.api.sizeColumnsToFit();
          this.gridQuiz.api.setRowData([]);
          this.listQuiz();
        }
      },
      onGridSizeChanged: () => {
        if (this.gridQuiz && this.gridQuiz.api) {
          this.gridQuiz.api.sizeColumnsToFit();
        }
      },
    };
  }

  listQuiz() {
    if (this.gridQuiz) {
      if (this.gridQuiz && this.gridQuiz.api) {
        this.subscriptions.push(
          this._serviceQuiz.getQuiz(this.showDisabled).subscribe({
            next: (data) => {
              const filter = this.gridQuiz.api.getFilterModel();
              this.gridQuiz.api.setRowData(data);
              this.gridQuiz.api.setFilterModel(filter);
            },
            error: (err) => {
              this.sweetAlertHelper.captureException(err);
            },
          })
        );
      }
    }
  }

  addNewQuiz() {
    this.showForm = true;
    this._serviceQuiz.setQuizData(undefined);
  }

  selectedQuiz(event: { data?: QuizGridRow }) {
    if (!isQuizGridRow(event.data)) {
      return;
    }
    this.loading.show();
    this.subscriptions.push(
      this._serviceQuiz.getQuizById(event.data.quizid)
        .pipe(finalize(() => this.loading.hiden()))
        .subscribe({
          next: (data: QuizClass) => {
            this._serviceQuiz.setQuizData(data);
            this.showForm = true;
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        })
    );
  }

  inCancelForm(cancel: boolean) {
    if (!cancel) {
      this.showForm = false;
    }
  }

  onGetDisabled(event: boolean) {
    this.showDisabled = event;
    this.listQuiz();
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach(subscription => {
        if (subscription) {
          subscription.unsubscribe();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/quiz/quiz.component.ts